import React from 'react';
import Loadable from 'react-loadable';

const LoadableComponent = Loadable({
  loader: () =>
    import(/* webpackChunkName: 'BottomCommentItemV2' */ './BottomCommentItemV2'),
  loading: () => null,
});

const BottomCommentItemV2Loader = props => <LoadableComponent {...props} />;

export default BottomCommentItemV2Loader;
